import './styles.scss';

export const KeyPointsSection = ({ header, children }) => {
    return (
        <div className="container" id="information-wrapper">
            <div className="solutions">
                {header}
                {children}
            </div>
        </div>
    );
};

export default KeyPointsSection;
